import { useImmer } from 'use-immer';

const useComplexState = useImmer;

export default useComplexState;
